import { useInfiniteQuery } from "@tanstack/react-query";

import { getAllProjects } from "../services/projectService";
import { Project } from "../utils/models";
import { useAppSelector } from "../store/configureStore";
import { useEffect } from "react";

export interface ProjectsResponse {
    totalProjects: number;
    projects: Project[];
    currentPage: number;
    nextPage: number;
    prevPage: number;
    totalPages: number;
    limit: number;
}

const initialData: ProjectsResponse = {
    totalProjects: 0,
    projects: [],
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
    totalPages: 0,
    limit: 0,
};

const useInternalProjects = () => {
    const projectQuery = useAppSelector((state) => state.projectsQuery);

    const query = useInfiniteQuery<ProjectsResponse, Error>({
        queryKey: ['internal-projects', projectQuery],
        initialPageParam: 1,
        refetchOnReconnect: 'always',
        queryFn: ({ pageParam = 1 }) => getAllProjects<ProjectsResponse>({ 
            params: {
                searchFields: projectQuery.searchFields ? projectQuery.searchFields.map(({ filterName }) => filterName).join(',') : undefined,
                searchValue: projectQuery.searchFields ? projectQuery.searchFields.map(({ filterValue }) => filterValue).join(',') : undefined,
                projectStatuses: projectQuery.projectStatus ? projectQuery.projectStatus?.join(',') : undefined,
                page: pageParam,
                limit: projectQuery.limit,
                inspectionTypeId: projectQuery.inspectionTypeId,
                startDate: projectQuery.startDate,
                endDate: projectQuery.endDate,
            }
        }),
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.nextPage ? allPages.length + 1 : undefined;
        },
        initialData: {
            pages: [initialData],
            pageParams: [undefined],    
        },
    });

    useEffect(() => {
        query.refetch();

		// eslint-disable-next-line
    }, [projectQuery]);

    return query;
};

export default useInternalProjects;